import type { OcpiAdminRepository } from '../data/ocpi-admin-repository';
import type { CpoSyncOutcome } from '../types/api-types';

export type OcpiModule = 'locations' | 'tariffs' | 'sessions' | 'cdrs';

export class SyncCpoOcpiDataUseCase {
  constructor(private readonly repository: OcpiAdminRepository) {}

  /** Incremental sync with backend retries and full-sync fallback */
  async execute(operatorId: number, connectionId: number, ocpiModule: OcpiModule): Promise<CpoSyncOutcome> {
    return this.repository.syncCpoOcpiData(operatorId, connectionId, ocpiModule);
  }
}
